import { render } from "./MonthlyAchivement.vue?vue&type=template&id=1ffc34f2&scoped=true"
import script from "./MonthlyAchivement.vue?vue&type=script&lang=js"
export * from "./MonthlyAchivement.vue?vue&type=script&lang=js"

import "./MonthlyAchivement.vue?vue&type=style&index=0&id=1ffc34f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffc34f2"]])

export default __exports__